import { Card } from '@radix-ui/themes'
import { CardHeader, CardTitle, CardContent } from './ui/card'
import { CheckCircle, CircleX, Loader2 } from 'lucide-react'
import { Button } from './ui/button'
import { useVerifyEmail } from '@/hooks/use-Auth'
import { useLocation } from 'wouter'

const VerifyEmail = () => {
  const token = new URLSearchParams(window.location.search).get("token");
  const { data, isLoading, isSuccess, isError, error } = useVerifyEmail()
  const [_, setLocation] = useLocation();

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-blue-600 to-purple-700">
      <Card className="w-full max-w-md mx-4 bg-white/90 backdrop-blur-sm shadow-xl">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl text-center font-bold">Email Verification</CardTitle>
        </CardHeader>
        <CardContent>
          { 
            isLoading
              &&
            <div className='' >
              <Loader2 className="w-full h-16 animate-spin text-primary mb-3" />
              <p className="text-center text-gray-600 animate-pulse">Your email is verifying......</p>
            </div>
          }

          { 
            isSuccess && data.success
              &&
            <div className='' >
              <CheckCircle size={60} className="w-full animate-spin-once text-green-600 mb-4"/>
              <p className="text-center text-green-500">{data.message}</p>
              <Button
                onClick={() => setLocation("/login")}
                className="w-full bg-blue-600 hover:bg-blue-700 mt-6"
              >
                Login Now
              </Button>
            </div>
          }

          {
            !token
              &&
            <div className='' >
              <CircleX size={60} className="w-full animate text-red-600 mb-4"/>
              <p className="text-center text-red-500">Verification Token is not found</p>
            </div>
          }

          { 
            isError
              &&
            <div className='' >
              <CircleX size={60} className="w-full animate text-red-600 mb-4"/>
              <p className="text-center text-red-500">{(error as Error).message}</p>
            </div>
          }
        </CardContent>
      </Card>
    </div>
  )
}

export default VerifyEmail